import { StyleSheet } from 'aphrodite';

export const styles = StyleSheet.create({
    
    tab_container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: "#ecececff",
        borderRadius: "2px",
        height: "50px",
        marginTop: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
    },

    tab: {
        display: "flex",
        flexDirection: "column",
        height: "50px",
        ":hover" :{
            cursor: "pointer",
            backgroundColor : "#ecececff",
            filter: "brightness(95%)"
        }
    },

    tab_content: {
        margin: "auto",
        paddingLeft: "30px",
        paddingRight: "30px"
    },  

    tab_bar: {
        height: "5px",
        backgroundColor: "#006bcfff",
        width: "100%"
    },
    
    hidden : {
        visibility: "hidden"
    },
    
    button_cp: {
        marginLeft: "auto",
        marginRight: "20px"
    },
});


// WEBPACK FOOTER //
// ./src/styles/TabBar.ts